export default {
	"helpers.ConversionFailed": "Conversion failed"
}